// extracted by mini-css-extract-plugin
export default {"crossSellGuestList":"crossSellGuestList__ZjU2Z"};